var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleJoinedVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F9F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1666 14.9846V14.4284C22.1666 13.1138 21.0288 12.1665 19.7777 12.1665H11.2221C9.97102 12.1665 8.83325 13.1138 8.83325 14.4284V21.5713C8.83325 22.8859 9.97102 23.8332 11.2221 23.8332H19.7777C21.0288 23.8332 22.1666 22.8859 22.1666 21.5713V21.0144L24.7548 22.3083C25.0088 22.4352 25.2912 22.4952 25.5749 22.4824C25.8586 22.4696 26.1343 22.3846 26.3759 22.2353C26.6175 22.086 26.817 21.8775 26.9553 21.6295C27.0937 21.3815 27.1664 21.1023 27.1666 20.8183V15.1812C27.1664 14.8972 27.0937 14.6175 26.9553 14.3695C26.817 14.1215 26.6175 13.913 26.3759 13.7638C26.1343 13.6145 25.8586 13.5294 25.5749 13.5167C25.2912 13.5039 25.009 13.5638 24.7549 13.6908L22.1666 14.9846ZM16.3333 15.4998C16.3333 15.0396 15.9602 14.6665 15.4999 14.6665C15.0397 14.6665 14.6666 15.0396 14.6666 15.4998V18.488L14.4225 18.2439C14.0971 17.9185 13.5694 17.9185 13.244 18.2439C12.9186 18.5694 12.9186 19.097 13.244 19.4224L14.9107 21.0891C15.2361 21.4145 15.7637 21.4145 16.0892 21.0891L17.7558 19.4224C18.0813 19.097 18.0813 18.5694 17.7558 18.2439C17.4304 17.9185 16.9028 17.9185 16.5773 18.2439L16.3333 18.488V15.4998Z",
    fill: "#1E2131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleJoinedVideoCall);
export default __webpack_public_path__ + "static/media/people-joined-video-call.4c918f20ecbc2ec9857ef3ebf42f6408.svg";
export { ForwardRef as ReactComponent };